import React, { useState } from "react";
import ShopingIcon from '../../../local-assets/membership/shopping-bag-icon.png';
import CheckinIcon from '../../../local-assets/membership/checkin-icon.png';
import SurveyIcon from '../../../local-assets/membership/survey-icon.png';
import MissionIcon from '../../../local-assets/membership/mission-icon.png';
import CardIcon from '../../../local-assets/membership/credit-card-down.png';
import BuildingIcon from '../../../local-assets/membership/building-icon.png';
import PhoneFull from '../../../local-assets/membership/full-phone-img.png';
import CheckIn from '../../../local-assets/membership/check-in.png';
import Mission from '../../../local-assets/membership/mission.png';
import Quiz from '../../../local-assets/membership/quiz.png';
import Tagihan from '../../../local-assets/membership/tagihan.png';
import TapIn from '../../../local-assets/membership/tap-in.png';

const CollectStamp = () => {
  // 1. Deklarasikan data di atas agar bisa dipakai sebagai default state
  const leftContents = [
    { title: "Belanja", content: "Unggah struk belanja Anda untuk mengumpulkan stamps", icon: ShopingIcon, img: PhoneFull },
    { title: "Checkin Mall", content: "Lakukan check-in di mall yang Anda kunjungi secara berkala", icon: CheckinIcon, img: CheckIn }, 
    { title: "Partisipasi Dalam Survey", content: "Partisipasi dengan menjawab sejumlah pertanyaan pada quiz yang tersedia", icon: SurveyIcon, img: Quiz }
  ];

  const rightContents = [
    { title: "Selesaikan Misi", content: "Selesaikan misi yang tersedia untuk dapatkan hadiah atau stamps", icon: MissionIcon, img: Mission },
    { title: "Tap in / Out di Hunianmu", content: "Daftarkan kartu Akses hunian Anda untuk mengumpulkan stamps dari tapping in dan tapping out", icon: CardIcon, img: TapIn }, 
    { title: "Bayar Tagihan Hunianmu", content: "Bayar tagihan IPL hunianmu setiap bulannya untuk mendapatkan stamps", icon: BuildingIcon, img: Tagihan }
  ];

  // 2. Buat state untuk melacak kotak mana yang aktif (Default: item pertama dari leftContents)
  const [activeBox, setActiveBox] = useState(leftContents[0]);
  
  // 3. Modifikasi fungsi renderBox untuk menerima seluruh objek 'item' dan event onClick
  const renderBox = (item, isDesktopRight) => {
    // Cek apakah judul kotak ini sama dengan judul kotak yang sedang aktif
    const isActive = activeBox.title === item.title;

    return (
      <div
        onClick={() => setActiveBox(item)} // Set kotak ini sebagai yang aktif saat diklik
        className={`bg-white rounded-2xl p-5 md:p-6 w-full md:w-[320px] shadow-sm border flex flex-row md:flex-col items-center ${
          !isDesktopRight ? 'md:items-end text-left md:text-right' : 'md:items-start text-left'
        } gap-4 md:gap-0 relative z-10 transition-all cursor-pointer hover:border-[#F36F21] hover:shadow-md ${
          // Jika aktif, ubah border jadi oranye. Jika tidak, abu-abu.
          isActive ? 'border-[#F36F21] shadow-md' : 'border-gray-200'
        }`}
      >
        {/* Ikon */}
        <img 
          src={item.icon} 
          alt={item.title} 
          className="h-10 w-10 object-contain flex-shrink-0 md:h-12 md:w-12 md:mb-5" 
        />
        
        {/* Teks */}
        <div className="flex flex-col">
          <h4 className="font-bold text-base md:text-lg text-[#101828] mb-1 md:mb-2 leading-snug">
            {item.title}
          </h4>
          <label className="text-xs md:text-sm text-[#475467] leading-relaxed font-normal cursor-pointer">
            {item.content}
          </label>
        </div>
      </div>
    );
  };

  return (
    <section id="collect-stamp" className="py-16 md:py-24 bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        
        <h3 className="text-2xl md:text-4xl font-bold text-[#101828] mb-12 md:mb-20 leading-tight">
          Cara Mengumpulkan Stamp di Summarecon Apps
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4 items-center relative">
          
          {/* GAMBAR HP (Paling Atas di Mobile, Tengah di Desktop) */}
          <div className="order-1 md:order-2 flex justify-center mb-10 md:mb-0 relative">
            <img 
              src={activeBox.img} // 4. Panggil gambar dari state activeBox
              alt={activeBox.title} 
              // Tambahkan transition-opacity agar saat ganti gambar terlihat lebih halus
              className="h-[450px] md:h-[600px] w-auto object-contain drop-shadow-2xl relative z-10 transition-opacity duration-300" 
            />
          </div>

          {/* KOTAK KIRI */}
          <div className="order-2 md:order-1 flex flex-col gap-4 md:gap-6 px-4 md:px-0">
            {leftContents.map((item, index) => (
              <div key={index} className="flex justify-center md:justify-end">
                {/* Kirim item langsung ke renderBox */}
                {renderBox(item, false)}
              </div>
            ))}
          </div>

          {/* KOTAK KANAN */}
          <div className="order-3 md:order-3 flex flex-col gap-4 md:gap-6 px-4 md:px-0">
            {rightContents.map((item, index) => (
              <div key={index} className="flex justify-center md:justify-start">
                {renderBox(item, true)}
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};
  
export default CollectStamp;